export const SET_ROW_META_DATA = "SET_ROW_META_DATA";
export const SET_SELECTED_ROW = "SET_SELECTED_ROW";
export const SET_HOVER_ROW = "SET_HOVER_ROW";
export const DEFINE_FILTER_MODEL = "DEFINE_FILTER_MODEL";
export const DEFINE_TOTAL_PAGES = "DEFINE_TOTAL_PAGES";
export const DEFINE_SORT_MODEL = "DEFINE_SORT_MODEL";